import React, { Component, Fragment, createRef } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Checkbox, message, Popconfirm, Modal, Tooltip, Typography } from 'antd';
import CpEmpty from '../../../components/CpEmpty';
import { inventoryCartList, inventoryDeleteList, inventoryUpdateList, inventorySuppliers, inventoryOrderTimeCategories, inventoryBrandList, inventoryCategoryList } from '../api';
import { companyTree } from '../../erpList/api';
import CpLoading from '../../../components/CpLoading';
import { CartProduct } from './cartProduct';
import { formateTree, treeToArray } from '../../../util/tool';
import { currency } from '../../quotationProduct/formatNumber';
// import CpSearchBar from '../../components/CpSearchBar';
// import CpLogo from '../../components/CpLogo';
// import { Index as CartForm } from './components/cartForm';
import './../style.less';

const { history } = window;
function calcNumber(record = {}) {
  // const { number, out_prop, out_norms_prop } = record;
  // const a = number / out_prop;
  // const b = Math.ceil(a / out_norms_prop) * out_norms_prop;
  // const c = (b * out_prop).toFixed(3);
  // return c;
  return record.number;
}

function calcOutNormsUnit(record = {}) {
  const { number, out_prop, out_norms_prop, sale_unit, out_norms_unit } = record;
  const calc_norm = `(${(out_norms_prop * out_prop).toFixed(3)}${sale_unit}/${out_norms_unit})`;
  const calc_num = `${Math.ceil((number / out_prop) / out_norms_prop).toFixed(3)}${out_norms_unit}`;
  return <><div>{calc_num}</div><div>{calc_norm}</div></>;
}

const columns = [
  { title: '全选', key: 'select', align: 'left', width: 88 },
  { title: '商品信息', key: 'sale_name', width: 300, align: 'center', },
  { title: 'ERP商品编码', key: 'out_sku_no', width: 140, align: 'center', },
  { title: 'SKU商品编码', key: 'sku_no', width: 140, align: 'center', },
  { title: '订货数量', key: 'number', width: 160, align: 'center', },
  { title: '商品单位', key: 'sale_unit', width: 120, align: 'center', },
  { title: '商品单价', key: 'norms_price', width: 120, align: 'center', },
  // // { title: 'RMS订货包规', key: 'out_norms_unit', width: 140, align: 'center', },
  // { title: '单价', key: 'norms_price', width: 100, align: 'center', },
  // // { title: 'RMS商品编码', key: 'out_sku_no', width: 120, align: 'center', },
  // { title: '建议补货量', key: 'proposal_number', width: 140, align: 'center', },
  // { title: 'SKU商品单位', key: 'sale_unit', width: 120, align: 'center', },
  // { title: '数量', key: 'number', width: 150, align: 'center', },
  // { title: '实际数量', key: 'real_number', width: 120, align: 'center', },
  // { title: '实际订货数量', key: 'out_norms_unit', width: 140, align: 'center', },
  { title: '操作', key: 'operation', width: 60, align: 'center' },
];
class CpmCart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectProducts: {}, // 记录选中的商品
      suppliers: {},   // 记录各个供应商的商品和选中商品数
      selectedAll: false, // 全选按钮
      totalPrice: 0,
      totalCount: 0,
      emptyStatus: 'purchaseOrder',
      loading: true,
      currentProduct: {},
      erpMap: {},
      pre_sale_goods_id: '',
      order_no: '',
      ids: [],
      plan: {},
      addressId: '',
      list: [],
      selectProductInfo: {},
      number: undefined,
      currentId: undefined,
      tree: [],
      originTree: [],
      suppliersList: [],
      categories: [],
      brandList: [],
      categoryList: [],
      productModalVisible: false,
      can_check_all: false,
      expected_time: undefined,
    };
    this.formRef = createRef();
  }
  init = async () => {
    try {
      let { selectProductInfo = {} } = this.state;
      const keys = Reflect.ownKeys(selectProductInfo);
      const formValues = this.formRef?.form?.getFieldsValue?.() || {};
      const { data: { data = {}, error, code } } = await inventoryCartList({ ...formValues, type: 2 });
      if (+code === 0) {
        const { list = [], expected_time = '' } = data;
        for (let item of list) {
          const { supplier_id, supplier_name } = item;
          if (keys.length) {
            const { selectedRowKeys = [] } = selectProductInfo[supplier_id] || { selectedRowKeys: [], selectedRows: [] };
            const currentItem = list.find(item => String(item.supplier_id) === String(supplier_id));
            const selectedRows = currentItem?.sale_list.filter(c => selectedRowKeys.includes(c.id)).filter(item => item.can_check);
            const newSelectedRowKeys = selectedRows.map(item => item.id);
            selectProductInfo[supplier_id] = { ...selectProductInfo[supplier_id], selectedRows, selectedRowKeys: newSelectedRowKeys };
          } else {
            selectProductInfo[supplier_id] = { selectedRowKeys: [], selectedRows: [], checked: false, supplier_id, supplier_name };
          }
        }
        this.setState({ list, selectProductInfo, loading: false, expected_time }, this.computeTotal);
      } else {
        message.error(error, .5, history.back());
      }
    } catch (error) {
      this.setState({ loading: false });
    }
  }
  async componentDidMount() {
    this.init();
    Promise.all([this.getSuppliers(), this.getSuppliersList(), this.getInventoryOrderTimeCategories(), this.getInventoryBrandList(), this.getInventoryCategoryList()]);
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  searchFn = () => this.init();
  async getSuppliersList() {
    const { data: { code, msg, data } } = await inventorySuppliers();
    if (+code === 0) {
      const { list = [] } = data;
      this.setState({ suppliersList: list });
    } else {
      message.error(msg);
    }
  }
  async getInventoryBrandList() {
    const { data: { code, msg, data } } = await inventoryBrandList();
    if (+code === 0) {
      const { list = [] } = data;
      this.setState({ brandList: list });
    } else {
      message.error(msg);
    }
  }
  async getInventoryCategoryList() {
    const { data: { code, msg, data } } = await inventoryCategoryList();
    if (+code === 0) {
      this.setState({ categoryList: data });
    } else {
      message.error(msg);
    }
  }
  getInventoryOrderTimeCategories = async () => {
    const { data: { data, msg, code } } = await inventoryOrderTimeCategories();
    if (+code === 0) {
      const { list = [] } = data;
      const categories = list.map(item => ({ category_id: item.id, category_name: item.name }));
      this.setState({ categories });
    } else {
      message.error(msg);
    }
  };
  getSuppliers = async () => {
    const { data: { code, data = [] } } = await companyTree();
    const companyId = localStorage.getItem('companyId');
    if (+code === 0) {
      const tree = formateTree(data, companyId);
      this.setState({ tree, originTree: treeToArray(data) });
    }
  }
  submitOrder = () => {
    const { selectProductInfo = {}, totalCount, expected_time } = this.state;
    if (!totalCount) {
      message.info('请先选择商品');
      return;
    }
    const keys = Reflect.ownKeys(selectProductInfo);
    const orderData = keys.filter(item => selectProductInfo[item]?.selectedRows?.length).map(item => {
      const { supplier_id = '', supplier_name = '', selectedRows = [] } = selectProductInfo[item] || {};
      const sale_list = selectedRows.map(s => ({ ...s, number: calcNumber(s) }));
      return { supplier_id, supplier_name, sale_list, expected_time };
    });
    localStorage.setItem('orderData', JSON.stringify(orderData));
    this.props.history.push(`/basic/proposalSubmit?type=3`);
  }
  add = (record) => this.modifyProduct({ ...record, number: +record.number + 1 });
  reduce = (record) => {
    const { number } = record;
    if (number <= 1) {
      message.info('商品数量不能再减少了');
      return;
    }
    this.modifyProduct({ ...record, number: +number - 1 });
  }
  inputChanged = (e, record) => {
    const { id: currentId } = record;
    let value = e.target.value;
    const number = Number(value.replace(/\D/g, ''));
    this.setState({ currentId, number });
  }
  onBlur = (e, record) => {
    let value = e.target.value;
    const number = Number(value.replace(/\D/g, ''));
    if (isNaN(number)) {
      message.info('请输入有效数字');
      return;
    }
    if (number < 1) {
      message.info('商品数量不能小于最小起订量');
      // return;
    }
    this.modifyProduct({ ...record, number: Math.max(1, number) });
  }
  modifyProduct = async record => {
    const { data: { msg, code } } = await inventoryUpdateList({ ...record });
    if (+code === 0) {
      const { number, supplier_id, id } = record;
      const { list = [], selectProductInfo = {} } = this.state;
      for (let item of list) {
        if (String(item.supplier_id) === String(supplier_id)) {
          for (let sItem of (item.sale_list || [])) {
            sItem.number = String(sItem.id) === String(id) ? Math.max(number, 1) : sItem.number;
          }
        }
      }
      selectProductInfo[supplier_id].selectedRows = (selectProductInfo?.[supplier_id]?.selectedRows || []).map(item => String(item.id) === String(id) ? { ...item, number: Math.max(number, 1) } : item);
      this.setState({ list: [...list], currentId: undefined, selectProductInfo }, () => {
        this.computeTotal();
      });
    } else {
      message.error(msg, 1, () => this.init());
    }
  }
  removeProductBase = async values => {
    const { data: { msg, code } } = await inventoryDeleteList({ id: values });
    if (+code === 0) {
      const { selectProductInfo = {}, list = [] } = this.state;
      const replenishTypeKeys = Object.keys(selectProductInfo) || [];
      if (values.length) {
        const newList = list.map(item => ({ ...item, sale_list: item.sale_list.filter(sItem => !values.includes(sItem.id)) })).filter(item => item.sale_list.length);
        for (let item of replenishTypeKeys) {
          const { selectedRowKeys = [], selectedRows = [] } = selectProductInfo[item];
          const newSelectedRowKeys = selectedRowKeys.filter(sItem => !values.includes(sItem));
          const newSelectedRows = selectedRows.filter(sItem => !values.includes(sItem.id));
          const currentList = newList.find(s => String(s.supplier_id) === String(item));
          const currentSaleList = currentList?.sale_list || [];
          const checked = currentSaleList.length && currentSaleList.length === newSelectedRowKeys.length;
          selectProductInfo[item] = { ...selectProductInfo[item], selectedRowKeys: newSelectedRowKeys, selectedRows: newSelectedRows, checked };
        }
        this.setState({ selectProductInfo, list: newList }, this.computeTotal);
      }
    } else {
      message.error(msg, 1, () => this.init());
    }
  }
  removeProduct = ({ id }) => this.removeProductBase([id]);
  removeProducts = () => {
    const { selectProductInfo = {}, totalCount } = this.state;
    if (totalCount) {
      const replenishTypeValues = Object.values(selectProductInfo) || [];
      const values = replenishTypeValues.reduce((acc, cur) => [...acc, ...(cur?.selectedRowKeys || [])], []);
      this.removeProductBase(values);
    }
  }
  removeProductsAll = () => {
    const { list = [] } = this.state;
    const productIds = list.reduce((acc, cur) => ([...acc, ...(cur.sale_list || [])]), []).map(item => item.id);
    this.removeProductBase(productIds);
  }
  selectedAll = (e) => {
    let checked = e.target.checked;
    const { list = [], selectProductInfo } = this.state;
    if (checked) {
      for (let item of list) {
        const { supplier_id, sale_list = [] } = item;
        const filter_sale_list = sale_list.filter(item => item.can_check);
        const selectedRowKeys = filter_sale_list.map(item => item.id);
        const checked = filter_sale_list.length && filter_sale_list.length === selectedRowKeys.length;
        selectProductInfo[supplier_id] = { ...selectProductInfo[supplier_id], selectedRowKeys, selectedRows: filter_sale_list, checked };
      }
    } else {
      for (let item of Reflect.ownKeys(selectProductInfo)) {
        selectProductInfo[item] = { ...selectProductInfo[item], checked: false, selectedRowKeys: [], selectedRows: [] };
      }
    }
    this.setState({
      selectProductInfo,
      selectedAll: checked
    }, () => {
      this.computeTotal();
    });
  }
  computeTotal = () => {
    const { selectProductInfo = {}, list = [] } = this.state;
    const replenishTypeValues = Object.values(selectProductInfo) || [];
    const values = replenishTypeValues.reduce((acc, cur) => [...acc, ...(cur?.selectedRows || [])], []);
    const totalCount = values.length;
    const allList = list.reduce((pre, next) => [...pre, ...next.sale_list], []).filter(item => item.can_check);
    const selectedAll = allList.length && allList.length === values.length;
    const can_check_all = allList.length;
    this.setState({ totalCount, selectedAll, can_check_all });
  }
  rowSelectionChange = (e, item, supplier_id) => {
    const { selectProductInfo = {}, list = [] } = this.state;
    const { selectedRowKeys = [], selectedRows = [] } = selectProductInfo[+supplier_id];
    let newSelectedRows = [];
    if (selectedRowKeys.includes(item.id)) {
      newSelectedRows = newSelectedRows.filter(c => c === item.id);
    } else {
      newSelectedRows = [...selectedRows, item];
    }
    newSelectedRows = newSelectedRows.filter(item => item.can_check);
    const newSelectedRowKeys = newSelectedRows.map(item => item.id);
    const current = (list.find(item => String(item.supplier_id) === String(supplier_id))?.sale_list || []).filter(item => item.can_check);
    selectProductInfo[+supplier_id] = { ...selectProductInfo[+supplier_id], selectedRowKeys: newSelectedRowKeys, selectedRows: newSelectedRows, checked: current.length === newSelectedRowKeys.length };
    this.setState({ selectProductInfo: { ...selectProductInfo } }, this.computeTotal);
  }
  proposalCartTitleChange = (e, supplier_id) => {
    const { selectProductInfo = {}, list = [] } = this.state;
    const { target: { checked } } = e;
    const current = (list.find(item => String(item.supplier_id) === String(supplier_id))?.sale_list || []).filter(item => item.can_check);
    if (checked) {
      const selectedRowKeys = current.map(item => item.id);
      selectProductInfo[supplier_id] = { ...selectProductInfo[supplier_id], selectedRowKeys, selectedRows: current, checked };
    } else {
      selectProductInfo[supplier_id] = { ...selectProductInfo[supplier_id], selectedRowKeys: [], selectedRows: [], checked };
    }
    this.setState({ selectProductInfo: { ...selectProductInfo } }, () => {
      this.computeTotal();
    });
  }
  openProductModal = () => {
    this.setState({ productModalVisible: true });
  }
  closeProductModal = () => {
    this.setState({ productModalVisible: false });
  }
  refresh = () => {
    this.init();
    this.closeProductModal();
  }

  render() {
    // const { selectedAll, totalCount, emptyStatus, searchValue = '', searchType = '', list = [], selectProductInfo = {}, number, currentId, loading, suppliersList = [], categories = [], categoryList = [], brandList = [], productModalVisible, can_check_all } = this.state;
    const { selectedAll, totalCount, emptyStatus, list = [], selectProductInfo = {}, loading, suppliersList = [], categoryList = [], brandList = [], productModalVisible, can_check_all, expected_time } = this.state;
    const empty = (<div className="cart-empty"><CpEmpty status={emptyStatus} history={this.props.history} /></div>);
    // const header = (<div className="proposal-cart-top"><CpLogo /><div style={{ marginLeft: '40px' }}><CpSearchBar searchValue={searchValue} searchType={searchType} searchValueChanged={this.searchValueChanged} searchTypeChanged={this.searchTypeChanged} /></div></div>);
    return (
      <div className="proposal-cart">
        {/* <div className="title">订货清单</div> */}
        {/* {header} */}
        {/* <Row>
          <Col span={6} offset={18} style={{ textAlign: 'right', marginBottom: 10 }}>
            <Button type='primary' onClick={() => this.props.history.push('/basic/user/proposalCart/purchasingList')}>常购清单</Button>
            <Button type='primary' style={{ marginLeft: 10 }} onClick={this.openProductModal}>添加商品</Button>
          </Col>
        </Row> */}
        {/* <CartForm ref={el => this.formRef = el}  {...{ suppliersList, categories, searchFn: this.searchFn, openProductModal: this.openProductModal }} /> */}
        {loading ? <CpLoading></CpLoading> :
          <>{
            list.length <= 0 ? empty :
              <>
                <table className="cp-table">
                  <thead><tr>{(columns || []).map((item, index) => <th key={index} style={{ textAlign: item.align, width: item.width }}>{index === 0 && (<Checkbox style={{ margin: '0px 8px' }} disabled={!can_check_all} checked={selectedAll} onChange={this.selectedAll}></Checkbox>)} {item.key === 'real_number' ? <Tooltip title='依据RMS订货包规计算得出，实际按订货包规进行订货'><span style={{ cursor: 'pointer' }}>{item.title}</span></Tooltip> : item.title}</th>)}</tr></thead>
                  <tbody>
                    {
                      (list || [])?.map((item, index) => {
                        const { supplier_id, supplier_name } = item;
                        return (
                          <Fragment key={index}>
                            <tr>
                              <td colSpan={columns.length - 3} className="td-group">
                                <div className='proposal-cart-table-title'>
                                  <Checkbox disabled={!(item.sale_list || []).filter(item => item.can_check).length} onChange={(e) => this.proposalCartTitleChange(e, supplier_id)} checked={selectProductInfo?.[supplier_id]?.checked}></Checkbox><span style={{ paddingLeft: 26 }}>供应商：</span><span>{supplier_name}</span>
                                </div>
                              </td>
                              <td colSpan={3}><div style={{ textAlign: 'right' }}>期望到货时间:{expected_time}</div></td>
                            </tr>
                            {(item.sale_list || []).map((sItem, sIndex) => {
                              return <tr key={sIndex}>
                                {(columns || []).map((cItem, cIndex) => {
                                  const { key } = cItem;
                                  const base = ['sku_no', 'out_sku_no', 'sale_unit', 'proposal_number', 'number'];
                                  const { sale_image, sale_name, unit_packing, can_check, false_reason } = sItem;
                                  if (key === 'sale_name') {
                                    return <td key={`${supplier_id}_${cIndex}`} colSpan={2} style={{ textAlign: cItem.align, width: cItem.width }}>
                                      <div className='proposal-cart-table-product' >
                                        <div className='proposal-cart-table-product-left' ><Checkbox style={{ margin: '0px 8px' }} disabled={!can_check} checked={selectProductInfo?.[supplier_id]?.selectedRowKeys?.includes(sItem.id)} onChange={e => this.rowSelectionChange(e, sItem, supplier_id)}></Checkbox></div>
                                        <img className='proposal-cart-table-product-img' src={sale_image} alt='' />
                                        {/* <div className='proposal-cart-table-product-right' ><div>{sale_name}</div><div>{purchase_time}</div></div> */}
                                        <div className='proposal-cart-table-product-right' >
                                          <div>{sale_name}</div>
                                          <div>{unit_packing}</div>
                                        </div>
                                      </div>
                                    </td>;
                                  } else if (key === 'norms_price') {
                                    return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>{(isNaN(sItem[key]) || !sItem['can_check']) ? <Typography.Link style={{ fontSize: 12 }}>{sItem?.false_reason}</Typography.Link> : `¥${currency(sItem[key])}`}</td>;
                                  } else if (base.includes(key)) {
                                    return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>{sItem[key]}</td>;
                                  }
                                  //  else if (key === 'number') {
                                  //   return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>
                                  //     {/* <div className="countContainer">
                                  //       <a className="btn pointer" onClick={() => { this.reduce(sItem); }}>-</a>
                                  //       <Input className="input" defaultValue={sItem[key]} onChange={(e) => { this.inputChanged(e, sItem); }} value={currentId === sItem.id ? number : sItem[key]} onBlur={(e) => { this.onBlur(e, sItem); }} onPressEnter={(e) => { this.onBlur(e, sItem); }} />
                                  //       <a className="btn pointer" onClick={() => { this.add(sItem); }}>+</a>
                                  //     </div> */}
                                  //   </td>;
                                  // }
                                  //  else if (key === 'norms_price') {
                                  //   return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>{sItem.can_check ? sItem[key] : <Typography.Link style={{ fontSize: 12 }}>{sItem?.false_reason}</Typography.Link>}</td>;
                                  // }
                                  else if (key === 'real_number') {
                                    return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>
                                      {can_check ? calcNumber(sItem) : false_reason}
                                    </td>;
                                  }
                                  else if (key === 'out_norms_unit') {
                                    return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>{calcOutNormsUnit(sItem)}</td>;
                                  }
                                  else if (key === 'out_norms_unit') {
                                    return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}>{`${sItem.out_norms_prop}${sItem.out_unit} / ${sItem.out_norms_unit}`}</td>;
                                  } else if (key === 'operation') {
                                    return <td key={`${supplier_id}_${cIndex}`} style={{ textAlign: cItem.align, width: cItem.width }}><Popconfirm title="确定要删除商品吗?" onConfirm={() => this.removeProduct(sItem)} okText="确认" cancelText="取消"><Button type='link' className='pointer'>删除</Button></Popconfirm></td>;
                                  } else {
                                    return null;
                                  }
                                })}
                              </tr>;
                            })}
                          </Fragment>
                        );
                      })
                    }
                  </tbody>
                </table>
                <div className="whitespace"></div>
                <div className={true ? 'bottom fixed-bottom' : 'bottom'}>
                  <div className="bottom-content">
                    <div className="bottom-left">
                      <div className="bottom-select-all"><Checkbox style={{ margin: '0px 8px' }} disabled={!can_check_all} checked={selectedAll} onChange={(e) => { this.selectedAll(e); }}></Checkbox>全选</div>
                      <div className="bottom-delete-select">
                        <span className='pointer' onClick={() => { this.removeProducts(); }}>删除所选商品</span>
                        {/* <span className='pointer' style={{ marginLeft: 20 }} onClick={() => { this.removeProductsAll(); }}>清空</span> */}
                      </div>
                    </div>
                    <div className="bottom-right">
                      <div className="bottom-select-count">已选择<span className="bottom-select-count-value">{totalCount}</span>件商品</div>
                      <Button className="bottom-submit-settlement" disabled={!totalCount} type='primary' onClick={this.submitOrder}>提交订货单</Button>
                    </div>
                  </div>
                </div>
              </>
          }
          </>
        }
        <Modal title='添加商品' open={productModalVisible} destroyOnClose width={1200} centered onCancel={this.closeProductModal} getContainer={false} footer={false} >
          <CartProduct {...{ suppliersList, categoryList, brandList, refresh: this.refresh, type: 'cart' }} />
        </Modal>
      </div>
    );
  }
}
export default withRouter(CpmCart);